import { render, staticRenderFns } from "./DefaultHead.vue?vue&type=template&id=55f7f920&scoped=true&"
import script from "./DefaultHead.vue?vue&type=script&lang=js&"
export * from "./DefaultHead.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHead.vue?vue&type=style&index=0&id=55f7f920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f7f920",
  null
  
)

export default component.exports